import React, { useState, useEffect } from 'react';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { Divider } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import AccountMembers from '../AccountMembers';
import ParentMembers from '../AccountMembers/ParentMembers';
import NewParentMembers from '../NewParentMembers';
import AccountMerging from '../MergeAccounts';
import {
  isParent,
  isActualSuperAdmin,
  isActualAdmin,
} from '@projectK/context/RolesProvider';

const LinkedAccounts = () => {
  const { user } = useAuthUser();
  const [searchuserMember, setSearchuserMember] = useState('');
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [membersData, setMembersData] = useState([]);
  const fetchMembersData = async () => {
    try {
      const response = await jwtAxios.get(`/user-members/${user?.id}`, {
        params: {
          search: searchuserMember,
          page,
          perPage: 5,
        },
      });
      const { data } = response;
      setMembersData(data?.list);
      setTotal(response?.data?.total);
      data?.list?.length === 0 && page > 0 && setPage(page - 1);
    } catch (error) {
      setMembersData([]);
    }
  };
  useEffect(() => {
    fetchMembersData();
  }, [searchuserMember, page]);
  return (
    <>
      {isParent(user) && (
        <>
          <AccountMembers
            fetchMembersData={fetchMembersData}
            settings={membersData}
            total={total}
            page={page}
            setPage={setPage}
            setSearchQuery={setSearchuserMember}
          />
          <Divider
            sx={{
              marginTop: 4,
              marginBottom: 3,
            }}
          />
          {(isActualSuperAdmin(user) || isActualAdmin(user)) && (
            <>
              <AccountMerging fetchMembers={fetchMembersData} />
              <Divider
                sx={{
                  marginTop: 4,
                  marginBottom: 3,
                }}
              />
            </>
          )}
          <NewParentMembers />
        </>
      )}
      {(isActualSuperAdmin(user) || isActualAdmin(user)) && !isParent(user) ? (
          <ParentMembers />
      ) : null}
    </>
  );
};

export default LinkedAccounts;
